import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class FileService {
  generateBonReception(idUser, refFacture, refOperation) {
    return api.get(
      UtilsUrl.fileRetailURL() +
        "/retail/uploadFile/generateBonReception/" +
        idUser +
        "/" +
        refFacture +
        "/" +
        refOperation
    );
  }

  generateBonReceptionSell(idUser, refFacture, refOperation) {
    return api.get(
      UtilsUrl.fileRetailURL() +
        "/sales/uploadFileSelling/generateBonReception/" +
        idUser +
        "/" +
        refFacture +
        "/" +
        refOperation
    );
  }

  generateBLFactureSell(idUser, refFacture, refOperation) {
    return api.get(
      UtilsUrl.fileRetailURL() +
        "/sales/uploadFileSelling/genererBonLivraisonn/" +
        idUser +
        "/" +
        refFacture +
        "/" +
        refOperation
    );
  }
  generateBonTransfert(idUser, refTransfert, type) {
    return api.get(
      UtilsUrl.fileRetailURL() +
        "/retail/uploadFile/generateBonTransfert/" +
        idUser +
        "/" +
        refTransfert +
        "/" +
        type
    );
  }
}
export default new FileService();
